const ITEMS = [
  { text: "THE ABSTRACTS STUDIO", gold: false },
  { text: "ORIGINAL ABSTRACTS & LANDSCAPES", gold: true },
  { text: "INSTANT ARTWORK UPLOAD & LISTING", gold: false },
  { text: "BESPOKE COMMISSIONS OPEN", gold: true },
  { text: "WORLDWIDE COURIER SHIPPING", gold: false },
];

export default function Marquee() {
  const seq = [...ITEMS, ...ITEMS];
  return (
    <div className="py-4 bg-ground-elevated border-b border-line overflow-hidden whitespace-nowrap">
      <div className="mq-track mono-tag text-xs tracking-[0.25em] uppercase text-slate-400">
        {seq.map((item, i) => (
          <span key={i} className={`mx-6 ${item.gold ? "text-gold" : ""}`}>
            ★ {item.text}
          </span>
        ))}
      </div>
    </div>
  );
}
